function getCurrentTheme() {
    return localStorage.getItem('theme') || 'system';
}

function setTheme(theme) {
    const validThemes = ['light', 'dark', 'system'];
    if (!validThemes.includes(theme)) {
        theme = 'system';
    }
    
    localStorage.setItem('theme', theme);
    
    document.body.classList.remove('theme-light', 'theme-dark', 'theme-system');
    document.body.classList.add(`theme-${theme}`);
}

function toggleTheme() {
    const currentTheme = getCurrentTheme();
    const themeOrder = ['light', 'dark', 'system'];
    const currentIndex = themeOrder.indexOf(currentTheme);
    const nextIndex = (currentIndex + 1) % themeOrder.length;
    const nextTheme = themeOrder[nextIndex];
    
    setTheme(nextTheme);
    return nextTheme;
}

const init = () => {
    setTheme(getCurrentTheme());

    document.querySelector('.theme-toggle').addEventListener('click', () => {
        toggleTheme();
    });    
}

export default { init };